<template>
  <div>
    <section
      class="banner green"
      data-src="images/search-banner.jpg"
      ref="banner"
    >
      <v-container class="body">
        <v-row align="center">
          <v-col>
            <h3 v-if="this.query">U heeft gezocht op "{{ this.query }}"</h3>
            <h1>{{ total }} zoekresultaten</h1>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <section id="search-results">
      <v-container>
        <v-row align="center">
          <v-col>
            <v-text-field
              ref="search-bar"
              filled rounded
              hide-details
              v-model="searchBarValue"
              label="Zoek op bv. Productnaam, productnummer, ..."
              @keyup.enter="submitSearch"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row v-if="results.products && Object.keys(results.products).length">
          <v-col cols="12">
            <h1>Producten ({{Object.keys(results.products).length}}):</h1>
            <v-divider/>
          </v-col>
          <v-col
            v-for="(item, uid) in results.products"
            cols="12" sm="4" md="3"
            :key="uid"
          >
            <product-item :item="item" :uid="uid"/>
          </v-col>
        </v-row>

        <v-divider v-if="results.products && Object.keys(results.products).length && results.misc && Object.keys(results.misc).length" class="my-4"/>

        <v-row v-if="results.misc && Object.keys(results.misc).length" align="center">
          <v-col
            v-if="results.products && Object.keys(results.products).length"
            cols="12"
            class="pb-0"
          >
            <h1 class="pl-4 pb-2">Overig ({{Object.keys(results.misc).length}}):</h1>
            <v-divider/>
          </v-col>
          <v-col cols="12" :class="{'pt-0': results.products && Object.keys(results.products).length}">
            <v-list>
              <template v-for="(item, uid, i) in results.misc">
                <v-divider
                  :key="`divider-${i}`"
                  v-if="i !== 0"
                ></v-divider>
                <v-list-item
                  two-line
                  :key="uid"
                  nuxt
                  :to="`/${item.slug}`"
                >
                  <v-list-item-content>
                    <v-list-item-title>{{item.title}}</v-list-item-title>
                    <v-list-item-subtitle>{{item.slug}}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-list>
          </v-col>
        </v-row>

        <v-divider v-if="pages > 1" class="my-4"/>

        <v-pagination
          v-model="page"
          v-if="pages > 1"
          :length="pages"
          class="pb-4"
          :total-visible="10"
        ></v-pagination>
      </v-container>
    </section>
  </div>
</template>

<script>
	import ProductItem from '@/components/pages/ProductOverview/Product'
	const perPage = 30;

	const structuredData = {
		"@context": "http://www.schema.org",
		"@type": "LocalBusiness",
		"name": "Avontuurlijk spelen - Goede Speelprojecten",
		"url": "https://avontuurlijkspelen.com",
		"logo": "https://avontuurlijkspelen.com/logo.svg",
		"image": "https://avontuurlijkspelen.com/office.jpg",
		"address": {
			"@type": "PostalAddress",
			"streetAddress": "Kraaivenstraat 23-12",
			"addressLocality": "Tilburg",
			"addressRegion": "Noord-Brabant",
			"postalCode": "5018 AB",
			"addressCountry": "Nederland"
		},
		"openingHours": "Mo, Tu, We, Th 08:30-17:00 Fr 08:30-15:00",
		"contactPoint": {
			"@type": "ContactPoint",
			"telephone": "+31 13 455 16 05",
			"contactType": "sales"
		}
	}

	export default {
		name: 'SearchPage',
		layout: 'empty',
    components: {ProductItem},
		data() {
			return {
				results: {
					products: [],
          misc: []
        },
				pages: 0,
				page: parseInt(this.$route.query.page),
        total: 0,
        query: this.$route.query.query,
				searchBarValue: this.$route.query.query
			}
		},
		computed: {
			favorites() {
				return this.$store.state.favorites
			},
		},
    watch: {
	    page(page) {
		    this.$router.push({query: {page: page, query: this.query}})
		    this.loadItems()
	    },
	    '$route'(to, from) {
	    	if (this.query !== to.query.query) {
	    		this.query = to.query.query
          this.loadItems()
        }

		    // noinspection EqualityComparisonWithCoercionJS
		    if (to.query.page != from.query.page) {
			    this.page = parseInt(to.query.page)
		    }
	    }
    },
    methods: {
	    async loadItems() {
	    	if (!this.query) {return;}

		    const storiesResult = await this.$storyapi.get('cdn/stories', {
			    'search_term': this.query,
			    'is_published': true,
          'excluding_ids': '5116692',
			    'story_only': true,
			    'per_page': perPage,
			    'page': this.page,
			    'sort_by': 'position:DESC',
		    });

		    if (!storiesResult.data.stories) {return;}

		    this.total = storiesResult.total;
		    this.pages = Math.ceil(storiesResult.total / perPage);

		    const products = {};
		    const misc = {};
		    storiesResult.data.stories.forEach((story) => {
			    const result = {
				    slug: story.full_slug,
				    title: story.content.name || story.name,
            component: story.content.component
			    };

          if (story.content.component === 'page_product') {
	          let image = null
	          if ((story.content.images).length) {
		          image = story.content.images[0].image
	          }
	          else if ((story.content.renders).length) {
		          image = story.content.renders[0].image
	          }
	          else if ((story.content.blueprints).length) {
		          image = story.content.blueprints[0].image
	          }

            products[story.uuid] = Object.assign({
	            productLine: story.content.productLine,
	            articleNumber: story.content.articleNumber,
	            favorite: this.favorites.includes(story.uuid),
              image
            }, result)
          } else {
          	misc[story.uuid] = result
          }
		    });

		    this.results = {
		    	products, misc
        };
	    },
	    submitSearch() {
		    if (this.searchBarValue) {
			    this.$router.push({query: {query: this.searchBarValue}})
		    }
	    }
    },
		mounted() {
			const $banner = this.$refs.banner;

			if ($banner !== undefined) {
				if ($banner.dataset.src) {
					const img = new Image();

					img.src = $banner.dataset.src;
					img.onload = function() {
						$banner.style.backgroundImage = 'url(' + img.src + ')';
					};
				}
			}

			if (this.query) {
        if (!this.page >= 1 && this.pages > 0) {
          this.page = 1
        } else {
          this.loadItems()
        }
      }
		},
		head() {
			return {
				title: 'Avontuurlijk spelen - Goede Speelprojecten - Zoeken',
				meta: [
					{ name: 'robots', content: 'index, follow' },
					{ property: 'og:site_name', content: 'Avontuurlijk spelen - Goede Speelprojecten' },
					{ property: 'og:title', content: 'Goede Speelprojecten - Zoeken' },
          { property: 'og:image', content: `${process.env.BASE_URL}/opengraph/1200x628.jpg` },
          { property: 'og:image:width', content: '1200' },
          { property: 'og:image:height', content: '628' },
          { property: 'og:image', content: `${process.env.BASE_URL}/opengraph/1080x1920.jpg` },
          { property: 'og:image:width', content: '1080' },
          { property: 'og:image:height', content: '1920' },
				],
				__dangerouslyDisableSanitizers: ['script'],
				script: [{ innerHTML: JSON.stringify(structuredData), type: 'application/ld+json' }]
			};
		}
	}
</script>

<style lang="scss" scoped>
  @import "@/assets/scss/_variables.scss";

  #search-results {
    .container {
      max-width: $max-site-width;
    }

    .v-list {
      width: 100%;
      padding: 0;
    }
  }
</style>
